/** Every VITE_* read happens here, so a missing one is obvious at a glance. */
const raw = import.meta.env

/**
 * The mini program's API_URL includes the /api/v1 prefix and so must this. It
 * is an easy thing to leave off, and the failure is a wall of 404s rather than
 * anything that says "your URL is short", so append it rather than let that
 * happen.
 */
const withApiPrefix = (url: string) => {
  const trimmed = url.replace(/\/$/, '')
  if (!trimmed) return ''
  return /\/api\/v\d+$/.test(trimmed) ? trimmed : `${trimmed}/api/v1`
}

export const env = {
  apiUrl: withApiPrefix(raw.VITE_API_URL || ''),
  devMode: raw.VITE_DEV_MODE === 'true',
  publicOrigin: (raw.VITE_PUBLIC_ORIGIN || '').replace(/\/$/, ''),
  icpNumber: raw.VITE_ICP_NUMBER || '',
  wechatOaAppId: raw.VITE_WECHAT_OA_APPID || ''
}

if (!env.apiUrl && !env.devMode) {
  console.warn('[tc][env] VITE_API_URL is empty and dev mode is off — every request will fail.')
}
